<div class="checkbox-container" (click)="toggleValue()" [tabindex]="tabindex" [ngClass]="{'checkbox-container-disabled':disabled}">
    <a class="checkbox checkbox-on" *ngIf="isCheckboxOn === true" tabindex="0"></a>
    <a class="checkbox checkbox-off" *ngIf="isCheckboxOn !== true" tabindex="0"></a>
    <label *ngIf="label" tabindex="0">{{label}}</label>
</div>